import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assumptions',
  templateUrl: './assumptions.component.html',
  styleUrls: ['./assumptions.component.scss']
})
export class AssumptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
